import useSWR from "swr";
import insightServices from "@/services/apiServices/insightServices/index.js";

const useSubcategory = () => {
  return useSWR("getSubCategoryData", insightServices.getSubCategoryData);
};

export default useSubcategory;
